import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=65c7cbf8&scoped=true&lang=pug"
import script from "./Iframe.vue?vue&type=script&lang=js"
export * from "./Iframe.vue?vue&type=script&lang=js"
import style0 from "./Iframe.styl?vue&type=style&index=0&id=65c7cbf8&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7cbf8",
  null
  
)

export default component.exports